import CompoundCourseRunStep from "@/models/CompoundCourseRunStep";

export default class Course {
    constructor(raw = {}) {
        this.id = raw.id ?? "-1";
        this.webLink = raw.webLink ?? "";
        this.zipName = raw.zipName ?? null;
        this.title = raw.title ?? "";
        this.isLocked = raw.isLocked ?? false;
        this.time = raw.time ?? null;
        this.requireBirthdate = raw.requireBirthdate ?? false;
        this.requireZvuExpirationDate = raw.requireZvuExpirationDate ?? false;
        this.requireIsHimself = raw.requireIsHimself ?? false;
        this.shopLink = raw.shopLink ?? "";
        this.imageRef = raw.imageRef ?? "";
        this.isCompound = raw.isCompound ?? false;
        this.parts = raw.parts ? raw.parts.map(part => new CompoundCourseRunStep(part)) : [];
        this.pdfs = raw.pdfs;
    }

    get courseRunUrl() {
        return "https://lms.behrendtonline.com/behrendt" + this.webLink;
    }

    isValid() {
        return this.title.length > 0;
    }
}
